import { Injector, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RedirectCommand, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { RouteSegment } from '@core/enums/route-segment.enum';
import { TenantsStore, TenantsStoreInstance } from '@core/stores/tenants/tenants.store';

export const createSitesDefaultRedirectCommand$ = (): Observable<RedirectCommand> => {
  const tenantsStore = inject(TenantsStore);
  const router = inject(Router);
  const injector = inject(Injector);

  return createSitesDefaultRedirectCommandFrom$(tenantsStore, router, injector);
};

export const createSitesDefaultRedirectCommandFrom$ = (
  tenantsStore: TenantsStoreInstance,
  router: Router,
  injector: Injector
): Observable<RedirectCommand> => {
  tenantsStore.ensureTenantsLoaded();

  return toObservable(tenantsStore.hasResolved, { injector }).pipe(
    filter((hasResolved) => hasResolved),
    take(1),
    switchMap(() => toObservable(tenantsStore.singleSite, { injector }).pipe(take(1))),
    map((singleSite) => {
      const route = singleSite ? ['/', RouteSegment.Sites, singleSite.id, RouteSegment.Overview] : ['/', RouteSegment.Sites];
      return new RedirectCommand(router.createUrlTree(route), { replaceUrl: true });
    })
  );
};
